(function () {
  'use strict';

  function normalize(str) {
    return (str || '').trim().toLowerCase();
  }

  function parseData(scriptEl) {
    try {
      var parsed = JSON.parse(scriptEl.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.warn('[cl-lens-type-cards] Failed to parse data:', e);
      return [];
    }
  }

  function findSectionModal(sectionId) {
    return document.querySelector('#cl-lens-modal-' + sectionId);
  }

  function findMatch(data, optionValue) {
    return data.find(function (item) {
      return normalize(item.matching_option_title) === normalize(optionValue);
    }) || null;
  }

  function appendDetails(container, matchData) {
    if (!container || !matchData) return;

    if (matchData.description && !container.querySelector('.cl-ltc-desc')) {
      var desc = document.createElement('span');
      desc.className = 'cl-ltc-desc';
      desc.textContent = matchData.description;
      container.appendChild(desc);
    }

    if (matchData.badge && !container.querySelector('.cl-ltc-badge')) {
      var badge = document.createElement('span');
      badge.className = 'cl-ltc-badge';
      badge.textContent = matchData.badge;
      container.appendChild(badge);
    }
  }

  /* Legacy Easify DOM used by the source store. */
  function findLegacyWrapper(easifyContainer, optionName) {
    var wrappers = easifyContainer.querySelectorAll('.tpo_option-type-buttons-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      var input = wrappers[i].querySelector('input.tpo_buttons-input');
      if (!input) continue;
      var parts = input.name.split(',');
      var inputOptionName = parts[parts.length - 1].trim();
      if (normalize(inputOptionName) === normalize(optionName)) return wrappers[i];
    }
    return null;
  }

  function enhanceLegacy(wrapper, data) {
    wrapper.querySelectorAll('.tpo_buttons-wrapper').forEach(function (card) {
      var input = card.querySelector('input.tpo_buttons-input');
      var label = card.querySelector('label');
      if (!input || !label) return;
      appendDetails(label, findMatch(data, input.value));
    });
    wrapper.classList.add('cl-ltc-enhanced');
  }

  /* Current Easify DOM used by the destination store. The semantic po-* class
     prefixes are stable; the second generated class on each node is not. */
  function findModernRoot(easifyContainer, optionName) {
    var inputs = easifyContainer.querySelectorAll('input[type="hidden"][name^="properties["]');
    for (var i = 0; i < inputs.length; i++) {
      if (normalize(inputs[i].name) === normalize('properties[' + optionName + ']')) {
        return inputs[i].closest('.po-option-root');
      }
    }
    return null;
  }

  function enhanceModern(root, data) {
    var group = root.querySelector('.po-buttons-optionGroup');
    if (!group) return;

    root.classList.add('cl-ltc-enhanced', 'cl-ltc-modern');
    group.classList.add('cl-ltc-option-items');

    group.querySelectorAll('.po-disabledWrapper-root').forEach(function (card, index) {
      var optionLabel = card.querySelector('.po-buttonOption-label');
      var surface = card.querySelector('.po-optionItem-inner > .po-buttonOption-content');
      var details = card.querySelector('.po-optionItemLabel-contentLabelWrapper');
      var titleRow = card.querySelector('.po-buttonOption-labelRow');
      if (!optionLabel || !surface || !details || !titleRow) return;

      card.classList.add('cl-ltc-card');
      surface.classList.add('cl-ltc-card-surface');
      details.classList.add('cl-ltc-card-content');
      titleRow.classList.add('cl-ltc-title-row');

      var matchData = findMatch(data, optionLabel.textContent);
      appendDetails(details, matchData);

      if (index === 0 && !titleRow.querySelector('.po-buttonOption-price') && !titleRow.querySelector('.cl-ltc-free')) {
        var free = document.createElement('span');
        free.className = 'cl-ltc-free';
        free.textContent = 'Free';
        titleRow.appendChild(free);
      }
    });
  }

  function enhanceOption(easifyContainer, optionName, data) {
    var legacy = findLegacyWrapper(easifyContainer, optionName);
    if (legacy) enhanceLegacy(legacy, data);

    var modern = findModernRoot(easifyContainer, optionName);
    if (modern) enhanceModern(modern, data);

    return Boolean(legacy || modern);
  }

  function wireOption(easifyContainer, optionName, data) {
    var scheduled = false;

    function applyEnhancement() {
      scheduled = false;
      enhanceOption(easifyContainer, optionName, data);
    }

    applyEnhancement();

    /* Easify conditionally mounts and replaces option groups. Re-run the
       idempotent enhancer when React adds new nodes. */
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(applyEnhancement);
    });
    observer.observe(easifyContainer, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('[data-cl-ltc-data]').forEach(function (scriptEl) {
      var sectionId = scriptEl.getAttribute('data-cl-ltc-data');
      var optionName = scriptEl.getAttribute('data-cl-ltc-option');
      if (!optionName) return;

      var data = parseData(scriptEl);
      if (!data.length) return;

      var modal = findSectionModal(sectionId);
      if (!modal) return;

      var easifyContainer = modal.querySelector('.easify-product-options');
      if (!easifyContainer) return;

      wireOption(easifyContainer, optionName, data);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
